import { toast } from 'react-toastify';
import authorChapterServices from 'src/Services/WebApiHandler/authorChapterServices';
import { instructorServices } from 'src/Services/WebApiHandler/instructorServices';
import webBookServices from 'src/Services/WebApiHandler/webBookServices';

const HelperFunction = {
  authorUpdateChapter: (content, menuType) => {
    // const updateCon = document.getElementById(`bookContent-${content._id}`).innerHTML;

    if (content.permissions.queryOn === 'chapter') {
      let updateData = {
        book_id: content.book_id,
        chapter_name: content.chapter_name,
        public_visibility: content.public_visibility,
      };
      if (menuType === 'REGULAR') {
        updateData.chapter_content = content.regular_content;
        if (content.chapter_content) updateData.chapter_express_content = content.chapter_content;
      } else {
        if (content.chapter_content) updateData.chapter_content = content.chapter_content;
        updateData.chapter_express_content = content.regular_content;
      }
      authorChapterServices
        .updateChapterApi(content._id, updateData)
        .then((response) => {
          if (response.code === 200) {
            toast.success('Content Successfully Updated');
          } else {
            toast.error(response.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },

  instructorUpdateChapter: (content, id) => {
    // const updateCon = document.getElementById(`bookContent-${content._id}`).innerHTML;
    console.log('zzzzzzzzzzzzzzzzz', content);
    // Update Chapter content
    let updateData = {
      book_id_clone: id,
      chapter_name_clone: content.chapter_name,
      chapter_content_clone: content.updateCon,
    };
    instructorServices
      .instructorChapterUpdate(content._id, updateData)
      .then((response) => {
        if (response.code === 200) {
          toast.success('Content Successfully Updated');
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  headerOneUpdate: (content, updateCon, htmltype, type) => {
    let updateData = {
      book_id: content.book_id,
      public_visibility: content.public_visibility,
    };

    if (type === 'header-1') {
      // Update header one
      updateData.header1_name = content.header1_name;
      if (htmltype === 'REGULAR') {
        updateData.header1_content = updateCon;
        if (content.express_content) updateData.header1_express_content = content.express_content;
      } else {
        if (content.regular_content) updateData.header1_content = content.regular_content;
        updateData.header1_express_content = updateCon;
      }
      webBookServices
        .updateChapterHeaderOneApi(content._id, updateData)
        .then((response) => {
          if (response.code === 200) {
            toast.success('Content Successfully Updated');
          } else {
            toast.error(response.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },

  headerTwoUpdate: (content, updateCon, htmltype, type) => {
    let updateData = {
      book_id: content.book_id,
      header2_name: content.header2_name,
      public_visibility: content.public_visibility,
    };
    // updateData.header2_name = content.header1_name;
    if (type === 'header-2') {
      if (htmltype === 'REGULAR') {
        updateData.header2_content = updateCon;
        if (content.express_content) updateData.header2_express_content = content.express_content;
      } else {
        if (content.regular_content) updateData.header2_content = content.regular_content;
        updateData.header2_express_content = updateCon;
      }
      webBookServices
        .updateChapterHeaderTwoApi(content._id, updateData)
        .then((response) => {
          if (response.code === 200) {
            toast.success('Content Successfully Updated');
          } else {
            toast.error(response.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },

  headerThreeUpdate: (content, updateCon, htmltype, type) => {
    let updateData = {
      book_id: content.book_id,
      public_visibility: content.public_visibility,
    };
    if (type === 'header-3') {
      // Update Header three
      updateData.header3_name = content.header3_name;
      if (htmltype === 'REGULAR') {
        updateData.header3_content = updateCon;
        if (content.express_content) updateData.header3_express_content = content.express_content;
      } else {
        if (content.regular_content) updateData.header3_content = content.regular_content;
        updateData.header3_express_content = updateCon;
      }
      webBookServices
        .updateChapterHeaderThreeApi(content._id, updateData)
        .then((response) => {
          if (response.code === 200) {
            toast.success('Content Successfully Updated');
          } else {
            toast.error(response.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },

  headerOneInstructorUpdate: (content, updateCon, id) => {
    let updateData = {
      book_id_clone: id,
      header1_name_clone: content.header1_name,
      header1_content_clone: updateCon,
    };
    instructorServices
      .instructorHeaderOneUpdate(content._id, updateData)
      .then((response) => {
        if (response.code === 200) {
          toast.success('Content Successfully Updated');
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  headerTwoInstructorUpdate: (content, updateCon, id) => {
    let updateData = {
      book_id_clone: id,
      header2_name_clone: content.header2_name,
      header2_content_clone: updateCon,
    };

    instructorServices
      .instructorHeaderTwoUpdate(content._id, updateData)
      .then((response) => {
        if (response.code === 200) {
          toast.success('Content Successfully Updated');
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  headerThreeInstructorUpdate: (content, updateCon, id) => {
    let updateData = {
      book_id_clone: id,
      header3_name_clone: content.header3_name,
      header3_content_clone: updateCon,
    };

    instructorServices
      .instructorHeaderThreeUpdate(content._id, updateData)
      .then((response) => {
        if (response.code === 200) {
          toast.success('Content Successfully Updated');
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  loadScript: () => {
    // const script = document.createElement('script');
    // script.type = 'text/javascript';
    // script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML'; // use the location of your MathJax
    // script.id = 'math-script';
    // var config =
    //   'MathJax.Hub.Config({' +
    //   'extensions: ["tex2jax.js"],' +
    //   'jax: ["input/TeX","output/HTML-CSS"]' +
    //   '});' +
    //   'MathJax.Hub.Startup.onload();';
    // if (window.opera) {
    //   script.innerHTML = config;
    // } else {
    //   script.text = config;
    // }
    // script.addEventListener('load', function () {
    //   window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
    // });
    // return script;
  },
};

export default HelperFunction;
